import PropTypes from 'prop-types';
import { useCallback } from 'react';
import styled from 'styled-components';
import ReactPaginate from 'react-paginate';

import { theme } from '_constants/theme';
import { ICONS_ALIASES } from '_constants/icons';

import Icon from '_components/atomic/Icon';

const { colors, fontSizes, spaces } = theme;

const StyledPaginate = styled(ReactPaginate)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  list-style-type: none;
  margin-bottom: 0;
  padding: 0;

  li {
    a {
      display: flex;
      align-items: center;
      padding-top: ${spaces.smallX}px;
      padding-bottom: ${spaces.smallX}px;
      padding-left: ${spaces.smallX}px;
      padding-right: ${spaces.smallX}px;
      margin-left: ${spaces.smallX}px;
      margin-right: ${spaces.smallX}px;
      font-family: 'Aeonik';
      font-size: ${fontSizes.regular}px;
      font-style: normal;
      font-weight: 400;
      color: ${colors.gray[700]};

      &:not([href]):not([class]):hover {
        color: ${colors.blue[500]};
      }
    }

    &.selected {
      a {
        border-bottom: 3px solid ${colors.blue[500]};
        font-weight: 600;
        color: ${colors.blue[500]};
      }
    }

    &.previous {
      a {
        padding-left: 0;
        margin-left: 0;
      }
    }

    &.next {
      a {
        padding-right: 0;
        margin-right: 0;
      }
    }

    &.disabled {
      a {
        pointer-events: none;
      }
    }
  }
`;

const Paginate = ({ pageCount, currentPage, onPageChange }) => {
  const handlePageChange = useCallback(
    (data) => {
      onPageChange(data.selected);
    },
    [onPageChange]
  );

  return (
    <StyledPaginate
      pageRangeDisplayed={1}
      marginPagesDisplayed={1}
      previousLabel={
        <Icon
          alias={ICONS_ALIASES.arrowLeft}
          color={currentPage === 0 ? colors.gray[500] : colors.blue[500]}
        />
      }
      nextLabel={
        <Icon
          alias={ICONS_ALIASES.arrowRight}
          color={
            currentPage === pageCount - 1 ? colors.gray[500] : colors.blue[500]
          }
        />
      }
      pageCount={pageCount}
      forcePage={currentPage}
      onPageChange={handlePageChange}
    />
  );
};

Paginate.propTypes = {
  pageCount: PropTypes.number,
  currentPage: PropTypes.number,
  onPageChange: PropTypes.func,
};

export default Paginate;
